export default __webpack_public_path__ + "static/media/woman-deciding-between-cpf-and-loan.73e93ef7.svg";